import { baseApi } from "@/redux/api/baseApi";

const OrderVideoStatusApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrderVideoStageStatus: builder.query({
        query: ({ orderId, videoId }) => ({
          url: `/order-video-stage-status/get-status/${orderId}/${videoId}`,
          method: "GET",
        }),
        // providesTags: ["orderVideoStatus"],
      }),
  }),
});

export const {
    useGetOrderVideoStageStatusQuery
  
} = OrderVideoStatusApi;
